module.exports = __webpack_public_path__ + "static/intellect-devourer-mtg_clb-22ae678670eee10bf3a7172cc0614930.jpg";